(() => {
  const init = root => root.querySelectorAll('.ss-kit-form').forEach(form => {
    if (form.dataset.ready) return;
    form.dataset.ready = 'true';
    const selects = Array.from(form.querySelectorAll('[data-kit-select]'));
    const button = form.querySelector('[data-kit-add]');
    const total = form.querySelector('[data-kit-total]');
    const label = form.querySelector('[data-kit-total-label]');
    const status = form.querySelector('.ss-kit-status');
    const cartLink = form.querySelector('.ss-kit-cart');
    const currency = form.dataset.currency || 'USD';
    let busy = false;
    let uncertain = false;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency });
    const update = () => {
      const ready = selects.length >= 2 && selects.every(select => !select.disabled && select.value && !select.selectedOptions[0].disabled);
      button.disabled = !ready || busy || uncertain;
      if (ready) {
        const cents = selects.reduce((sum, select) => sum + Number(select.selectedOptions[0].dataset.price), 0);
        total.textContent = money.format(cents / 100) + ' ' + currency;
        label.textContent = form.dataset.totalLabel;
      } else if (form.hasAttribute('data-empty-total')) {
        total.textContent = form.dataset.emptyTotal;
      }
    };
    selects.forEach(select => select.addEventListener('change', update));
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (button.disabled || busy || uncertain) return;
      const endpoint = new URL(form.action + '.js', location.origin);
      const destination = new URL(form.dataset.cartUrl, location.origin);
      if (endpoint.origin !== location.origin || destination.origin !== location.origin) return;
      const items = selects.map(select => ({ id: select.value, quantity: 1 }));
      const controls = Array.from(form.querySelectorAll('select'));
      const disabledStates = controls.map(control => control.disabled);
      controls.forEach(control => { control.disabled = true; });
      busy = true;
      button.disabled = true;
      button.textContent = button.dataset.adding;
      form.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(endpoint.href, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const result = await response.json();
        if (!response.ok || !Array.isArray(result.items) || result.items.length !== items.length) throw new Error('Cart update unconfirmed');
        location.assign(destination.href);
      } catch {
        uncertain = true;
        status.textContent = form.dataset.error;
        status.hidden = false;
        cartLink.hidden = false;
        cartLink.focus();
        button.textContent = button.dataset.add;
      } finally {
        controls.forEach((control, index) => { control.disabled = disabledStates[index]; });
        busy = false;
        form.removeAttribute('aria-busy');
        update();
      }
    });
    update();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
